<template>
  <b-row class="justify-content-center py-5">
    <b-col sm="10" md="8" lg="6">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <h1>Register</h1>
          <p class="text-muted">Create your account</p>

          <RegisterForm />
        </b-card-body>
        <b-card-footer class="p-4">
          <span class="text-muted">Already have an account?&nbsp;</span>
          <router-link id="register-login" :to="{ name: 'Login' }">
            Login
          </router-link>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";

import RegisterForm from "@/components/RegisterForm";

export default {
  components: {
    RegisterForm
  },

  metaInfo: {
    titleTemplate: "Register - %s"
  },

  data: () => ({
    isLoading: false
  }),

  computed: {
    ...mapState(["user"])
  },

  watch: {
    "user.id": {
      handler: function(user) {
        if (user) {
          const redirectPath = this.$route.query.goto
            ? decodeURIComponent(this.$route.query.goto)
            : "/dashboard";
          delete this.$route.query.goto;

          this.$router.push({ path: redirectPath, query: this.$route.query });
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.register-view {
  .btn {
    width: 100%;
  }
}
</style>
